import { NgModule } from '@angular/core';

import { PolicyRoutingModule } from './policy-routing.module';
import { PolicyComponent } from './policy.component';
import { CustomLayoutModule } from '../../custom-layout/custom-layout.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/modules/materia.module';


@NgModule({
  declarations: [PolicyComponent],
  imports: [
    CommonModule,
    PolicyRoutingModule,
    CustomLayoutModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule
  ],
  providers: [
    CustomizationService
  ],
})
export class PolicyModule { }
